// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__cUnhQ","navbar__links":"Navbar_navbar__links__0Pdqk","navbar__link":"Navbar_navbar__link__JGAIY","navbar__link--active":"Navbar_navbar__link--active__ZtcdK"};